// export const BASE_URL = "http://34.122.18.220:8080";
export const BASE_URL = "https://iespoc.soukhyatech.com/api";
// export const BASE_URL = "http://localhost:8080";
// export const BASE_URL = "http://103.49.103.118:8080"

export const login = `/user-service/api/auth/login`;
export const getCustomerDetail = "/be-service/ies/users";
export const getDashBoardDetails = "/be-service/ies/dashboard";
export const getOrPostSensors = "/be-service/sensors/customerSensors?size=1000"
export const reportDownLoad = "/be-service/sensors/reports/download"
export const getReports = "/be-service/sensors/reports"
export const getOrPostSystems = "/be-service/systems/customerSystems";
export const getOrPostSites = "/be-service/sites/customerSites";
export const sitesEndpoint = "/be-service/sites";
export const webServiceUrl = `${BASE_URL.replace(/^http/, 'ws').replace(/\/api$/, '')}/be-service/ws/sensors?token=`;
// export const webServiceUrl = "ws://103.49.103.118:8080/be-service/ws/sensors?token=";
